export default __webpack_public_path__ + "static/slide03-85bfcff3f19ab05da738262bebf0c8e8.png";